<!-- Bouton Retour au parcours appelant ou à l'accueil -->
@if (!estProvenanceExterne) {
  <app-bouton-retour-accueil />
} @else {
  <app-bouton-retour-parcours-externe />
}
